'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiSelectionBars = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ScopedD3Base = require('../ScopedD3Base');

var _ScopedD3Base2 = _interopRequireDefault(_ScopedD3Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var d3 = require('d3');

// general
var margin = { top: 0, right: 10, bottom: 0, left: 10 };

var defaultOptions = {
  maxBarHeight: 15,
  minRowPadding: 2
};

var multiSelectionBars = exports.multiSelectionBars = (0, _ScopedD3Base2.default)(function (_ref) {
  var spanData = _ref.spanData,
      svg = _ref.svg,
      g = _ref.g,
      tooltip = _ref.tooltip;
  var getContainer = spanData.getContainer,
      colors = spanData.colors,
      options = spanData.options,
      data = spanData.data,
      min = spanData.min,
      height = spanData.height,
      width = spanData.width;


  var opts = _extends({}, defaultOptions, options || {});
  var colorFunction = opts.colors && typeof opts.colors === 'function' ? opts.colors : function () {
    return '#944';
  };

  // establish margin up front, replace top-level g 
  g = g.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
  width = width - margin.left - margin.right;

  var xScale = 100.0;

  var barHeight = Math.min.apply(null, data.map(function (d, i) {
    return (data[i + 1] ? data[i + 1].rect.offsetY : height) - data[i].rect.offsetY - opts.minRowPadding * 2;
  }).concat([opts.maxBarHeight]));

  var rowPadding = function rowPadding(i) {
    return ((data[i + 1] ? data[i + 1].rect.offsetY : height) - data[i].rect.offsetY - barHeight) / 2;
  };

  // 25/50/75 grid lines for x
  g.call(d3.axisBottom(d3.scaleLinear().domain([0, 100]).range([0, width])).tickValues([25, 50, 75]).tickSize(height).tickFormat(function (d) {
    return d;
  })).call(function (g) {
    return g.select('.domain').remove();
  }).call(function (g) {
    return g.selectAll('.tick').attr('opacity', 0.2);
  });

  var rowsInd = new Array(data.length).fill().map(function (d, i) {
    return i;
  });

  var rows = g.selectAll('g.row').data(rowsInd).enter().append('g').attr('class', 'row').attr('transform', function (d, i) {
    return 'translate(0, ' + (data[i].rect.offsetY + rowPadding(i)) + ')';
  });

  var rowsInner = rows.append('g').attr('transform', function (d) {
    return 'scale(0,1)';
  });

  rowsInner.transition().delay(300).duration(1000).attr('transform', function (d) {
    return 'scale(1)';
  });

  var boxes = rowsInner.selectAll('rect').data(function (i) {
    return [{ i: i, d: data[i] }];
  }).enter().append('rect').attr('class', 'box').attr('y', 0).attr('height', barHeight).attr('x', 0).attr('fill', function (_ref2) {
    var i = _ref2.i,
        d = _ref2.d;
    return colorFunction(i, d.percent);
  }).attr('width', function (_ref3) {
    var d = _ref3.d;
    return d.percent ? d.percent * 100 * 1 / xScale * width : 0;
  });

  var labelText = rowsInner.selectAll('text').data(function (i) {
    return [{ i: i, d: data[i] }];
  }).enter().append('text').attr('dominant-baseline', 'hanging').attr('text-anchor', function (_ref4) {
    var d = _ref4.d;
    return d.percent > .90 ? 'end' : 'start';
  }).attr('fill', function (_ref5) {
    var d = _ref5.d;
    return d.percent > .9 ? 'white' : 'black';
  }).attr('y', 0).attr('x', function (_ref6) {
    var d = _ref6.d;
    return d.percent ? d.percent * 100 * 1 / xScale * width + (d.percent > .9 ? -2 : 2) : 0;
  }).style('font-size', Math.round(barHeight) + 'px').text(function (_ref7) {
    var d = _ref7.d;
    return Math.round(d.percent ? d.percent * 100 : 0) + '% ';
  });

  boxes.on("mouseover", function (_ref8) {
    var d = _ref8.d,
        i = _ref8.i;

    tooltip.transition().duration(200).style("opacity", .9);
    tooltip.html('\n        <div class="tip">\n          ' + (d.percent * 100).toFixed(0) + '%\n        </div>\n      ').style("left", Math.round(d3.event.layerX || d3.event.offsetX) + "px").style("top", Math.round(d3.event.layerY || d3.event.offsetY - 28) + "px");
  }).on("mouseout", function (d) {
    tooltip.transition().duration(500).style("opacity", 0);
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/react-likert/lib/components/visualizations/MultipleSelections.js
// module id = 771
// module chunks = 168707334958949